import {Component, OnDestroy, OnInit} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {Params, Router} from '@angular/router';
import {map, Observable, Subject, takeUntil} from 'rxjs';

import * as jose from 'jose';

import {ApiService, AppService, LocalStorageService} from 'shared/services';
import {ContentState} from 'shared/types';
import {ListState, SubmitState} from 'shared/interfaces';
import {ContentStatus} from 'shared/enums';
import {OrganizationModel, TokenUserModel} from 'shared/models';
import {OrganizationUiComponent} from './organization-ui/organization-ui.component';
import {AuthService} from '../sign-in/shared/services/auth.service';
import {OrganizationsService} from './shared/services/organizations.service';

@Component({
  // selector: 'app-forgot-password',
  standalone: true,
  imports: [OrganizationUiComponent, AsyncPipe],
  templateUrl: './organization.component.html',
  providers: [
    OrganizationsService,
    AuthService,
  ],
})
export class OrganizationComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject<void>();

  // @TODO
  private submitState$!: Observable<ContentState<SubmitState<Params>>>;
  protected organizationsState$!: Observable<ContentState<ListState<OrganizationModel>>>;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private appService: AppService,
    private apiService: ApiService,
    private organizationsService: OrganizationsService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.initStates();
    this.initSubscriptions();

    this.organizationsService.listSubject.next({
      observable$: this.apiService
        .get('auth/organizations')
        .pipe(
          map((data: Params): ListState<OrganizationModel> => {
            const list: OrganizationModel[] = data['data'].map((item: Params): OrganizationModel =>
              OrganizationModel.getInstance(item)
            );

            // const paginator: Paginator = {
            //   total: data.total,
            //   perPage: data.perPage,
            //   currentPage: data.currentPage,
            //   lastPage: data.lastPage,
            //   // from: data.from,
            //   // to: data.to
            // };

            // return {list, paginator};
            return {list};
          })
        ),
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private initStates(): void {
    this.submitState$ = this.authService.getSubmitState$(true);
    this.organizationsState$ = this.organizationsService.listState$;
  }

  private initSubscriptions(): void {
    this.submitState$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((state: ContentState<SubmitState<Params>>) => {
        if (state.status === ContentStatus.OK) {
          // this.appService.token = state.token;

          // Guarda la informacion de session en el LocalStorage
          // this.appService.saveSessionInfoToLocalStorage();

          console.info('auth', state);

          // @ts-expect-error foo
          this.localStorageService.setItem('t', state.value.token);

          // const claims = jose.decodeJwt(state.value.token);
          const key = 'Dwka+p+QApjqBFAa2+ikJ6qwFtOu63+K5Tpk6PorUZ0=';
          // @ts-expect-error foo
          // JWT.decrypt(state.value.token, key, {alg: 'EdDSA'}).then((foo) => {
          //   console.info('JWT.decrypt', foo);
          // });

          const token = state.value.token;
          const claims = jose.decodeJwt(token);
          console.info('decodeJwt', claims);
          const tokenUser = TokenUserModel.getInstance(claims['data'] as Params);
          console.info('tokenUser', tokenUser);

          this.appService.token = token;
          this.appService.currentUser = tokenUser;

          // jose.jwtVerify(state.value.token, jose.EmbeddedJWK, {
          //   // issuer: 'urn:example:issuer',
          //   // audience: 'urn:example:audience',
          //   algorithms: ['EdDSA']
          // }).then((foo) => {
          //   console.info('JWT.jwtVerify', foo);
          // });

          // Redirecciona a la pagina de usuario
          this.router.navigate(['/']);
        }
      });
  }

  submit(data: Params) {
    // if (this.authForm.valid) {
    //   this.router.navigate(['/']);
    // } else {
    //   console.log('Form is invalid. Please check the fields.');
    // }
    console.info('submit', data);

    this.authService.submitSubject.next({
      observable$: this.apiService.save('auth/organizations', data, [], 'put')
      // .pipe(
      //   map((resData: Params): any => {
      //     return ViveroModel.getInstance(resData);
      //   }),
      //   map((model: MainModel) => {
      //     return {model};
      //   })
      // ),
    });
  }
}
